import { Loader2 } from 'lucide-react';
import { useDbState } from '../db/hooks';
import { useSettings } from '../data/settings';
import { useCanWrite } from '../account/useCanWrite';
import { OnboardingFlow } from './OnboardingFlow';

/**
 * Shows first-run setup until the account has finished or skipped it. Runs after sync's first
 * download, so a new device for an existing account goes straight to the app. Skipped in the demo
 * and for read-only (lapsed) accounts, which can't save anything.
 */
export function OnboardingGate({ children }: { children: React.ReactNode }) {
  const dbState = useDbState();
  const { settings, isLoading } = useSettings();
  const canWrite = useCanWrite();
  const demo = dbState.status === 'ready' && dbState.mode === 'demo';

  if (isLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-clinical-primary" aria-label="Loading" />
      </div>
    );
  }

  if (!settings.onboarding_done_at && canWrite && !demo) return <OnboardingFlow />;
  return <>{children}</>;
}
